<template>
  <div v-if="prepareRateCodeList.length > 0">
    <p style="margin-bottom: 10px;" class="avoid">
      <strong>Rate and conditions: apply for {{hotelName}}</strong> <br />
      <strong>Valid from: {{bindDateFromTo(contractStartDate, contractEndDate)}}</strong><br />
      Currency: <strong>{{currency}}</strong>
    </p>
    <div v-for="(rateCode, index) of prepareRateCodeList" :key="`rate-code-${index}`">
      <p style="margin: 20px 0 5px;" class="avoid">
        <strong>{{rateCode.name}}({{rateCode.code}}):</strong> {{bindIncludeBreakfast(rateCode.includeBreakfast)}}
      </p>
      <table style=" border-collapse: collapse; border: 1px solid #cccccc; width: 100%; margin-bottom: 20px;" class="avoid">
        <tr style="background: #f3f3f3" class="avoid">
          <th style="border: 1px solid #cccccc; padding: 3px; font-weight: bold; text-align: left;">
            <p><strong>Validity Period</strong></p>
          </th>
          <th v-for="(roomTypeItem) of rateCode.roomTypeList"
              style="border: 1px solid #cccccc; padding: 3px;font-weight: bold; text-align: left;"
              :key="roomTypeItem.id">
            <p>{{roomTypeItem.name}}</p>
          </th>
        </tr>
        <tr v-for="(periodDate, periodKey) of rateCode.periodDateList" class="avoid"
            :key="periodKey">
          <td style="border: 1px solid #cccccc; padding: 3px">
            <p>{{bindDateFromTo(periodDate.startDate, periodDate.endDate)}}</p>
          </td>
          <td v-for="(roomTypeItem) of rateCode.roomTypeList"
              style="border: 1px solid #cccccc; padding: 3px"
              :key="`room-id-2${roomTypeItem.id}`">
            <p>
              <span v-if="rateCode.periodList[periodKey][roomTypeItem.id] === undefined">-</span>
              <span v-if="rateCode.periodList[periodKey][roomTypeItem.id] !== undefined">{{numberFormat(rateCode.periodList[periodKey][roomTypeItem.id])}}</span>
            </p>
          </td>
        </tr>
      </table>
    </div>
    <div v-if="bindRateCodeRemark().trim() !== ''" class="editor-preview avoid">
      <p style="margin: 5px 0 5px;">
        <strong>Remark: </strong>
      </p>
      <div v-html="bindRateCodeRemark()"></div>
    </div>
  </div>
</template>
<script>
import { getISODateFormat, numberFormat } from '@/helpers'
import { isValidStartEndInPeriod, getPeriodStartDate, getPeriodEndDate, sortPeriodList, dateFormat } from '@/helpers/datetime'
import { STATUS, REMARK_TYPE } from '@/configs/constant'
import { applyRemarkTableStyle } from '@/domains/contract-domain'
import { get } from 'lodash'

export default {
  name: 'RateCode',
  props: {
    rateCodeList: {
      type: Array,
      default: () => {
        return []
      }
    },
    contractStartDate: {
      type: String,
      default: ''
    },
    contractEndDate: {
      type: String,
      default: ''
    },
    hotelName: {
      type: String,
      default: ''
    },
    currency: {
      type: String,
      default: 'THB'
    },
    remarkList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    prepareRateCodeList: function () {
      const contractStartDate = this.contractStartDate
      const contractEndDate = this.contractEndDate
      const processRateCodeList = []

      this.rateCodeList.forEach((rateCode) => {
        const periodList = {}
        const periodDateList = {}
        const roomTypeIdList = []
        const roomTypeList = []

        const rateDetailList = rateCode.rateDetail.filter((item) => {
          const roomTypeName = get(item, 'roomTypeName', undefined)
          const isValidPeriod = isValidStartEndInPeriod(contractStartDate, contractEndDate, item.startDate, item.endDate)

          return (isValidPeriod && roomTypeName !== undefined)
        })

        rateDetailList.sort(sortPeriodList)
        rateDetailList.forEach((item) => {
          const startDate = getPeriodStartDate(contractStartDate, item.startDate)
          const endDate = getPeriodEndDate(contractEndDate, item.endDate)
          const startDateStr = getISODateFormat(new Date(startDate))
          const endDateStr = getISODateFormat(new Date(endDate))

          const roomTypeId = item.roomTypeId
          const roomTypeName = item.roomTypeName
          const price = item.price
          const periodKey = `${startDateStr}_${endDateStr}`

          if (periodList[periodKey] === undefined) {
            periodList[periodKey] = {}
            periodDateList[periodKey] = {}
          }

          periodList[periodKey][roomTypeId] = price
          periodDateList[periodKey] = {
            startDate: startDate,
            endDate: endDate
          }

          if (!roomTypeIdList.includes(roomTypeId)) {
            roomTypeIdList.push(roomTypeId)

            const roomTypeItem = {
              id: roomTypeId,
              name: roomTypeName,
              price: price
            }
            roomTypeList.push(roomTypeItem)
          }
        })

        rateCode.periodList = periodList
        rateCode.periodDateList = periodDateList
        rateCode.roomTypeList = roomTypeList.sort((a, b) => {
          return (a.price > b.price) ? 1 : -1
        })

        const keyPeriodList = Object.keys(periodDateList)

        if (keyPeriodList.length > 0) {
          processRateCodeList.push(rateCode)
        }
      })

      return processRateCodeList
    }
  },
  data () {
    return {
      numberFormat: (number) => {
        return numberFormat(number)
      }
    }
  },
  methods: {
    bindDateFromTo: function (startDateStr, endDateStr) {
      let dateFromToStr = '-'
      if (startDateStr !== '' && endDateStr !== '') {
        const startDate = new Date(startDateStr)
        const endDate = new Date(endDateStr)
        dateFromToStr = `${dateFormat.short(startDate, 'en')} - ${dateFormat.short(endDate, 'en')}`
      }

      return dateFromToStr
    },
    bindIncludeBreakfast: function (status) {
      if (status === STATUS.ENABLE) {
        return 'Include Breakfast'
      }

      return ''
    },
    bindRateCodeRemark: function () {
      const remark = applyRemarkTableStyle(this.remarkList, REMARK_TYPE.RATE_CODE)

      return remark
    }
  }
}
</script>
<style scoped>
  p {
    display: block;
    margin-block-start: 0px;
    margin-block-end:0px;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
  }
  .remark > p {
    margin: 5px 0 10px;
  }
</style>
